<template lang="pug">
.auth-social-links__container.social-link__list
  .social-link__item.social-link__item_fb(
    @click.prevent="windowOpen('facebook')",
    target="_blank"
  )
    .social-link__item-icon.social-link__item-icon_google
    p.social-link__item-text.social-link__item-text_fb Фейсбук*
  .social-link__item.social-link__item_vk(
    @click.prevent="windowOpen('vkontakte')",
    target="_blank"
  )
    .social-link__item-icon.social-link__item-icon_vk
      include ../assets/svg/vk.svg
    p.social-link__item-text.social-link__item-text_vk ВКонтакте
  .social-link__item.social-link__item_google(
    @click.prevent="windowOpen('google')",
    target="_blank"
  )
    .social-link__item-icon.social-link__item-icon_google
      include ../assets/svg/google.svg
    p.social-link__item-text.social-link__item-text_google Google
</template>

<script>
export default {
  name: 'TheAuthorizationSocialLinkList',

  props: {
    windowOpen: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.auth-social-links__container {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;

  @include mobile {
    flex-direction: column;
    align-items: center;
  }
}

.social-link__item {
  display: flex;
  width: 200px;
  height: 45px;
  border-radius: 3px;
  align-items: center;
  padding-left: 22px;
  cursor: pointer;

  background-color: white;
  border: solid 1px #dbdbdb;

  @include hover {
    opacity: 0.7;
  }

  &_google {
    background-color: white;
    border: solid 1px #dbdbdb;
  }

  @include mobile {
    width: 240px;
    height: 40px;
    border-radius: 5px;
    border: solid 2px #576eae;
    background-color: white;
    margin-bottom: 8px;

    &_google {
      border-color: #4285f4;
    }

    &_vk {
      order: 1;
    }
  }
}

.social-link__item-text {
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #7e7e7e;

  &_fb {
    margin-left: 25px;
  }

  &_vk {
    margin-left: 28px;
  }

  &_google {
    margin-left: 26px;
  }

  @include mobile {
    line-height: normal;
    color: #576eae;
    margin-left: 35px !important;

    &_google {
      color: #4285f4;
    }
  }
}

.social-link__item-icon {
  display: flex;

  &_fb {
    svg {
      width: 12px;
      height: 25px;
    }

    .icon-fb__path {
      fill: white;
    }
    @include mobile {
      svg {
        width: 10px;
        height: 19px;
      }

      .icon-fb__path {
        fill: #576eae;
      }
    }
  }

  &_vk {
    svg {
      width: 31px;
      height: 18px;
    }

    .icon-vk__path {
      fill: white;
    }

    @include mobile {
      svg {
        width: 24px;
        height: 13px;
      }

      .icon-vk__path {
        fill: #5d80ab;
      }
    }
  }

  &_google {
    margin-left: 16px;

    svg {
      width: 25px;
      height: 25px;
    }

    @include mobile {
      margin-left: 0;
      svg {
        width: 20px;
        height: 20px;
      }
    }
  }

  @include mobile {
    width: 24px;
    justify-content: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheAuthorizationSocialLinkList.vue